<template>
  <v-card>
    <v-card-title> Nastavení </v-card-title>
    <v-form v-if="settings" @submit.prevent="saveData">
      <v-card-text>
        <div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.orderCommission"
                label="Výška provize (%)"
              ></v-text-field>
            </v-col>
            <v-card column>
              <v-container fluid>
                <v-row dense>
                  <v-col :cols="Number(6)">
                    <v-col>
                      <v-text-field
                        hide-details="auto"
                        outlined
                        filled
                        dense
                        v-model.number="
                          settings.defaultEstimate &&
                          settings.defaultEstimate.price
                        "
                        label="Price"
                      ></v-text-field>
                    </v-col>
                  </v-col>
                  <v-col :cols="Number(6)">
                    <v-col>
                      <v-text-field
                        hide-details="auto"
                        outlined
                        filled
                        dense
                        v-model.number="
                          settings.defaultEstimate &&
                          settings.defaultEstimate.duration
                        "
                        label="Duration"
                      ></v-text-field>
                    </v-col>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.hourPrice"
                label="Hodinová cena úklidu (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.detergentsPrice"
                label="Cena prostředků (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                hide-details="auto"
                outlined
                filled
                dense
                v-model.number="settings.orderCancellationPrice"
                label="Cena za zrušení úklidové služby (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  hide-details="auto"
                  outlined
                  filled
                  dense
                  v-model.number="settings.extraCleaningHourPrice"
                  label="Cena za přidanou hodinu úklidu (CZK)"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  hide-details="auto"
                  outlined
                  filled
                  dense
                  v-model.number="settings.fixedFee"
                  label="Fixní částka k úklidu (CZK)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-title class="mt-10">Nastavení slev</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="oneTimeOrderPercent"
                    label="Sleva na jednorázový úklid (%)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="weeklyOrderPercent"
                    label="Sleva na úklid každý týden (%)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="biweeklyOrderPercent"
                    label="Sleva na úklid každé dva týdny (%)"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model="monthlyOrderPercent"
                    label="Sleva na úklid každý měsíc (%)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-card-title class="mt-10">Nastavení DPH</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    hide-details="auto"
                    outlined
                    filled
                    dense
                    v-model.number="settings.vatRate"
                    label="Sazba DPH (%)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn small color="primary" class="mx-1" type="submit">Uložit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "SettingsCard",
  data() {
    return {
      settings: null
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.get("/v1/settings").then(({data}) => {
        this.settings = data;
      });
    },
    saveData() {
      const {
        blockedCreateNewCleaningServices,
        estimateConfiguration,
        expressCleaningPrice,
        _id,
        updatedAt,
        createdAt,
        ...rest
      } = this.settings;
      this.axios.patch("/v1/settings", rest).then(()=>{
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      }).catch((el)=>{
        if (el.response && el.response.data && el.response.data.errors){
          el.response.data.errors.forEach((error)=>{
            this.$store.commit('addAlert', {
              type: 'error',
              message: error.message
            })
          })
        }else{
          this.$store.commit('addAlert', {
            type: 'error',
            message: "Chyba"
          })
        }
      })
    },
  },
  computed: {
    booleanSelectItems() {
      return [
        {
          text: "Ano",
          value: true,
        },
        {
          text: "Ne",
          value: false,
        },
      ];
    },
    monthlyOrderPercent: {
      get() {
        return this.settings.discounts.monthlyOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'monthlyOrderPercent', Number(value) || 0);
      },
    },
    biweeklyOrderPercent: {
      get() {
        return this.settings.discounts.biweeklyOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'biweeklyOrderPercent', Number(value) || 0);
      },
    },
    oneTimeOrderPercent: {
      get() {
        return this.settings.discounts.oneTimeOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'oneTimeOrderPercent', Number(value) || 0);
      },
    },
    weeklyOrderPercent: {
      get() {
        return this.settings.discounts.weeklyOrderPercent || 0;
      },
      set(value) {
        this.$set(this.settings.discounts, 'weeklyOrderPercent', Number(value) || 0);
      },
    }
  },
};
</script>

<style scoped>
</style>